const tabList = () => {
  let tabslist = $(".tabs-list");

  $(tabslist).each(function () {
    let tabToggle = $(this).find("[data-toggle='tab']");
    let tabPaneWrapper = $("#" + tabToggle.first().attr("aria-controls")).parent();
    let tabPane = tabPaneWrapper.find(".tab-pane");

    tabToggle.on("click", function () {
      let target = $(this).data("target");

      tabToggle.removeClass("active");
      tabPane.hide();
      $(this).addClass("active");
      $(target).show();
    });

  });

}

export { tabList }
